// extracted by mini-css-extract-plugin
module.exports = {"comp":"JH_comp__EgIKq"};